export default (apr, flatPrice, loanTerm, flat) => ({
    apr,
    flat,
    flatPrice,
    loanTerm: Math.min(Math.max(loanTerm, 10), 30),
    calcLoanAmount: 0,
    monthlyPayment: 0,
    loanAmountValue: 0,
    init() {
        this.$watch('loanAmount, loanTerm', () => {
            this.loanTerm = Math.min(Math.max(this.loanTerm), 30);
            this.calculatePayment();
        });
    },
    nextStep() {
        this.show_form = true

        this.$nextTick(() => {

            let message = `Dobrý deň, mám záujem o nasledovný byt:
Byt: ${this.flat},
Cena bytu: ${this.formatCurrency(this.flatPrice, 0)},
Výška hypotéky:  ${this.formatCurrency(this.loanAmountValue, 0)},
Splatnosť: ${this.loanTerm} rokov,
Úroková sadzba: ${this.apr} %,
Mesačná splátka: ${this.formatCurrency(this.monthlyPayment, 0)}`;

            document.getElementById('your-message-hypo').value = message
        })
    },
    loanAmount() {
        this.loanAmountValue = Math.round(this.flatPrice * 0.8);
        return this.loanAmountValue;
    },
    calculatePayment() {
        let calc_loanAmount = parseInt(this.loanAmount.toString().replace(' ', ''));
        let apr = this.apr / 1200;
        let term = this.loanTerm * 12;
        const value = calc_loanAmount * (apr * Math.pow((1 + apr), term)) / (Math.pow((1 + apr), term) - 1);
        this.monthlyPayment = Number.isFinite(value) ? value : calc_loanAmount;
        if (Number.isFinite(value)) {
            this.$refs.monthlyPayment.innerHTML = this.formatCurrency(value);
        }
    },
    formatCurrency(value, decimals = 2) {
        return new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: decimals
        }).format(value);
    }
})
